import React from 'react';
import { Link } from 'react-router-dom';

const UnauthorizedPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-6 text-center">
      <h1 className="text-3xl font-bold text-red-600 mb-4">Akses Ditolak 🚫</h1>
      <p className="text-gray-700 mb-6">Anda tidak memiliki izin untuk mengakses halaman ini.</p>
      <Link
        to="/dashboard"
        className="px-5 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
      >
        Kembali ke Dashboard
      </Link>
    </div>
  );
};

export default UnauthorizedPage;
